/* Toast notifications — stacked top-right, glass card style */

let _container = null;

function _ensureContainer() {
  if (_container) return _container;
  _container = document.createElement('div');
  _container.className = 'toast-container';
  _container.setAttribute('aria-live', 'polite');
  document.body.appendChild(_container);
  return _container;
}

function _buildToast(kind, message) {
  const el = document.createElement('div');
  el.className = `toast toast-${kind}`;

  const icon = document.createElement('span');
  icon.className = 'toast-icon';
  if (kind === 'progress') {
    icon.innerHTML = '<span class="toast-spinner"></span>';
  } else if (kind === 'success') {
    icon.innerHTML = '<i class="ic ic-check-circle"></i>';
  } else if (kind === 'error') {
    icon.innerHTML = '<i class="ic ic-alert-triangle"></i>';
  } else {
    icon.innerHTML = '<i class="ic ic-alert-circle"></i>';
  }
  el.appendChild(icon);

  const body = document.createElement('span');
  body.className = 'toast-message';
  body.textContent = message;
  el.appendChild(body);

  return { el, body, icon };
}

function _dismiss(el) {
  if (!el || !el.parentNode) return;
  el.classList.remove('visible');
  setTimeout(() => { if (el.parentNode) el.parentNode.removeChild(el); }, 180);
}

/**
 * Show a toast.
 * @param {string} message
 * @param {"info"|"success"|"error"|"progress"} [kind="info"]
 * @param {{duration?: number}} [opts] duration in ms (0 = sticky, default 3500; progress is always sticky)
 * @returns {{update: (msg: string) => void, resolve: (msg: string, kind: "success"|"error"|"info") => void, dismiss: () => void}}
 */
export function notify(message, kind = 'info', opts = {}) {
  const container = _ensureContainer();
  const { el, body, icon } = _buildToast(kind, message);
  container.appendChild(el);
  requestAnimationFrame(() => el.classList.add('visible'));

  const sticky = kind === 'progress';
  const duration = opts.duration ?? (sticky ? 0 : 3500);
  let timer = null;
  if (duration > 0) timer = setTimeout(() => _dismiss(el), duration);

  return {
    update(msg) { body.textContent = msg; },
    resolve(msg, newKind) {
      if (timer) { clearTimeout(timer); timer = null; }
      el.className = `toast toast-${newKind} visible`;
      body.textContent = msg;
      // Rebuild icon for the new kind
      const fresh = _buildToast(newKind, msg);
      el.replaceChild(fresh.icon, icon);
      // Auto-dismiss
      setTimeout(() => _dismiss(el), 3000);
    },
    dismiss() {
      if (timer) { clearTimeout(timer); timer = null; }
      _dismiss(el);
    },
  };
}
